export default function initializeApp() {
    window.sharingApi = process.env.NODE_ENV === 'development' ? 'https://localhost:7142/api' : '/api';
}